module.exports = __webpack_public_path__ + "img/logo-full-nex.69182a04.png";